import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ClienteComboInternoOutput } from "src/app/@shared/models/consulta-detalhes-interno";
import { ConsultaDetalhesPorNRTInput } from "src/app/@shared/models/consulta-detalhes/consulta-detalhes.model";
import { ConsultaDetalheInternaService } from "src/app/services/consulta-detalhe-interna/consulta-detalhe-interna.service";
import { StorageService } from "src/app/services/storage/storage.service";

@Component({
  selector: "app-detalhe-formulario-nrt-interna",
  templateUrl: "./detalhe-formulario-nrt-interna.component.html",
  styleUrls: ["./detalhe-formulario-nrt-interna.component.scss"],
})
export class DetalheFormularioNrtInternaComponent implements OnInit {
  public external = StorageService.getExternalAccess();
  usuario = StorageService.getPerfilUsuario();
  isLoading: boolean = false;

  private onDestroy = new Subject<void>();
  clientes: ClienteComboInternoOutput[];
  public filteredClientes: ReplaySubject<ClienteComboInternoOutput[]> = new ReplaySubject<ClienteComboInternoOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();
  urlParams: any;


  formConsultaNrt = new FormGroup({
    codigoNrt: new FormControl('', Validators.required),
    cliente: new FormControl()
  });
  get codigoNrt() { return this.formConsultaNrt.get('codigoNrt').value; }
  get cliente() { return this.formConsultaNrt.get('cliente').value; }

  constructor(
    private consultaDetalhesService: ConsultaDetalheInternaService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
  ) {  }

  ngOnInit() {
    if(this.external == null) { this.listarClientes();}
    this.route.queryParamMap.subscribe((params) => {
      this.urlParams = { ...params };
    });
    if (this.urlParams.params.pedidoId) {
      this.formConsultaNrt.get("codigoNrt").setValue(this.urlParams.params.pedidoId);
      setTimeout(() => {
        this.search();
      }, 100);
    }
  }

  public async listarClientes() {
    return this.consultaDetalhesService.getClientesConsultaDetalhadaInterna().toPromise().then((response: ClienteComboInternoOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  public onInput: EventEmitter<ConsultaDetalhesPorNRTInput> = new EventEmitter();
  search()
  {
    this.onInput.emit({
      pedidoid: this.formConsultaNrt.get("codigoNrt").value
    });
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
